import { Component, OnInit, ViewChild } from '@angular/core';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeleteCategoryDialogComponent } from 'src/app/core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { AddHolidaysDialogComponent } from 'src/app/core/dialogs/add-holidays-dialog/add-holidays-dialog.component';
import { HolidaysService } from 'src/app/service/holidays.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BoardsService } from 'src/app/service/boards.service';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
export interface DialogData {
  performAction: string;
  placeholder: string;
  page;
}
export interface deleteHolidaysData {
  id;
  desc;
  page;
}
@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss'],
  standalone: false,  // NOSONAR
})
export class HolidaysComponent implements OnInit {
  gridApi: any;
  gridColumnApi: any
  gridOptions: GridOptions;
  setPagination = 'true';
  defaultColDef;
  paginationPageSize: number = 30;
  columnDefs;
  rowData;
  icons;
  context: any;
  successMessage = '';
  errorMessage = '';
  frameworkComponents: { btnCellRenderer: typeof BtnCellRenderer; };
  @ViewChild('agGrid', { static: true }) agGrid;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  selectedRows: any = [];
  tempData: any[];
  tempData2: any[];
  dynamicHeight: number;
  totalRecords = 0; // Replace with your actual total records count
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ]
  constructor(public dialog: MatDialog, private readonly router: Router,
    private readonly holidaysService: HolidaysService, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly boardService: BoardsService) {
    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.context = {
      componentParent: this
    };
    this.gridOptions = { suppressRowClickSelection: true }
    this.columnDefs = [
      {
        headerName: "YEAR", headerClass: "year", field: "year", width: 120,
        sortable: true, unSortIcon: true,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        autoHeight: true
      },
      {
        headerName: "DATE", headerClass: "date", field: "eventdate", width: 200,
        sortable: true, unSortIcon: true, autoHeight: true
      },
      {
        headerName: "DESCRIPTION", headerClass: "description", field: "description", width: 820,
        sortable: true, unSortIcon: true, autoHeight: true
      },
      {
        headerName: "ACTION", field: "holidays_action",
        width: 120, autoHeight: true,
        cellRenderer: BtnCellRenderer,
        cellRendererParams: {
          clicked: function (_field: any, _act: any) {
            // do something
          }
        }
      }];
    this.frameworkComponents = {
      btnCellRenderer: BtnCellRenderer
    };
    // this.rowData = [
    //   {
    //     year: "2021", date: "09/06/2021", description: "Summer Shut down",
    //     subtask: "", action: "01"
    //   },
    //   {
    //     year: "2021", date: "09/06/2021", description: "Summer Shut down",
    //     subtask: "", action: "01"
    //   }
    // ];
    this.icons = {
      sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
    };
    this.defaultColDef = {
      floatingFilter: true,
      wrapText: true
    };
  }
  goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }
  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }
  goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }
  onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); this.updatePaginationDetails(); }
  getCurrentPage(): boolean {
    this.currentPageNo = this.agGrid.api?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.agGrid.api?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.agGrid.api?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  rppChanged(event: any) {
    this.cPage = 1;
    this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    this.updatePaginationDetails();
  }
  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();
      this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
      this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
      this.totalRecords = this.gridApi.paginationGetRowCount();
      this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }
  sizeToFit() { this.gridApi.sizeColumnsToFit(); }
  openDialog(): void {
    console.info("open dialog");
    const dialogRef = this.dialog.open(AddHolidaysDialogComponent, {
      disableClose: true,
      width: '503px',
      data: { performAction: 'AddCell', placeholder: '' }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.info('The dialog was closed', result);
      if (result.event == 'AddCell') { // NOSONAR
        const dataArr = {
          "holidayId": null,
          "description": result.data1,
          "startdate": result.data2,
          "enddate": result.data3
        }
        console.info("data arr", dataArr);
        this.holidaysService.addholidays(dataArr).subscribe(result => {
          if (!result) {
            this.loadData();
            this.errorMessage = 'Event Already Found On/Between Date(s) Provided!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
          else if (result) {
            this.loadData();
            this.successMessage = 'Holiday added successfully!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
        });
      }
    });
  }
  loadData() {
    this.ngxUiLoaderService.start("loader-01");
    //API Integration
    this.rowData = [];
    this.tempData = [];
    this.tempData2 = [];
    this.holidaysService.getDetails().subscribe(result => {
      console.info("calling getdetails")
      if (result?.length > 0) {
        this.tempData = result;
        this.tempData.forEach(e => {
          const obj = {
            "holidayId": undefined, "eventdate": undefined, "description": undefined, "year": undefined
          };
          obj.holidayId = e.holidayId;
          obj.description = e.description;
          obj.eventdate = e.eventdate;
          obj.year = e.eventdate.slice(-4);
          this.tempData2.push(obj);
        });
        this.rowData = this.tempData2;
        if (this.rowData.length) {
					this.totalRecords = this.rowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        this.rowCount = this.rowData.length;
      }
      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  }
  ngOnInit(): void {
    // clear contingency data
    sessionStorage.removeItem('contData');
    this.boardService.deleteContingenyList().subscribe(_result => {
      // contingency list deleted
    });
    this.loadData();
  }
  deleteHolidaysRow(val) {
    let holiday_desc;
    let id;
    this.rowData.filter(x => x.holidayId == val).forEach(e => { // NOSONAR
      this.selectedRows.push(e);
      id = e.holidayId;
      holiday_desc = e.description;
      console.info("holiday id", id);
    });
    const dialogRef = this.dialog.open(DeleteCategoryDialogComponent, {
      disableClose: true,
      width: '510px',
      data: { id: id, desc: holiday_desc, page: "holidays" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.info('The dialog was closed', result);
        console.info("data to be deleted:", result.data);
        const deletejson = {
          "holidayID": result.data
        }
        this.deleteRecords(deletejson);
      }
    });
  }
  deleteRecords(dataArr) {
    this.ngxUiLoaderService.start("loader-01");
    this.holidaysService.deleteholidays(dataArr).subscribe(_result => {
      this.successMessage = 'Deleted Row(s) Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
      //fetch latest row data after deleting
      this.loadData();
    });
  }
  refreshData() {
    this.loadData();
  }
  onFilterChanged(params: FilterChangedEvent) {
    this.rowCount = params.api.getDisplayedRowCount();
  }
}